<template>
  <div>
    <v-btn icon @click="openDialog()"
    v-if="this.userOK && this.licenceOK">
      <v-icon :color="ui.btnColor">
        add
      </v-icon>
    </v-btn>
    <v-dialog v-model="dialog" :max-width="ui.sizeWidthDialogLarge">
      <v-card :color="ui.bkgdColor">
        <v-card-title :class="ui.textTitle">
          <v-layout row>
            <v-icon medium left :color="ui.iconColor"> add </v-icon>
            <span :class="ui.textTitle">
              Applications Launch
            </span>
            <v-spacer/>
          </v-layout>
        </v-card-title>
        <v-progress-linear :color="ui.btnColor" height="1" value="100"/>
        <v-card-text>
          <!-- BUSINESS / SAFETY  -->
          <v-layout class="mt-2"/>
          <div v-if="true" class="mt-4">
            <v-layout row class="text-xs-left ml-2 mr-2"
            v-if="true">
              <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                <v-avatar>
                <v-icon> {{this.defineDocumentFromTag("O1").icon}} </v-icon>
                </v-avatar>
                Create {{this.defineDocumentFromTag("O1").title}}
              </v-chip>
              <v-spacer/>
            </v-layout>
            <v-layout class="text-xs-left ml-4 mr-4 mt-2">
              <div :class="ui.textSubheading">
                {{this.defineDocumentFromTag("O1").card}}
              </div>
            </v-layout>
            <v-layout row class="mr-4">
              <v-spacer/>
              <OpsNew
              :data="{btnTitle: 'New'}"
              v-if="this.licenceOK && this.userOK"/>
            </v-layout>
          </div>
          <div v-if="true" class="mt-4">
            <v-layout row class="text-xs-left ml-2 mr-2"
            v-if="true">
              <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                <v-avatar>
                <v-icon> {{this.defineDocumentFromTag("W1").icon}} </v-icon>
                </v-avatar>
                Create {{this.defineDocumentFromTag("W1").title}}
              </v-chip>
              <v-spacer/>
            </v-layout>
            <v-layout class="text-xs-left ml-4 mr-4 mt-2">
              <div :class="ui.textSubheading">
                {{this.defineDocumentFromTag("W1").card}}
              </div>
            </v-layout>
            <v-layout row class="mr-4">
              <v-spacer/>
              <WorkRequestNew
              :data="{btnTitle: 'New'}"
              v-if="
              this.licenceOK &&
              this.userOK &&
              this.getUser.pref.select.fauth !== null
              "/>
            </v-layout>
          </div>
          <div v-if="true" class="mt-4">
            <v-layout row class="text-xs-left ml-2 mr-2"
            v-if="true">
              <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                <v-avatar>
                <v-icon> {{this.defineDocumentFromTag("E2").icon}} </v-icon>
                </v-avatar>
                Create {{this.defineDocumentFromTag("E2").title}}
              </v-chip>
              <v-spacer/>
            </v-layout>
            <v-layout class="text-xs-left ml-4 mr-4 mt-2">
              <div :class="ui.textSubheading">
                {{this.defineDocumentFromTag("E2").card}}
              </div>
            </v-layout>
            <v-layout row class="mr-4">
              <v-spacer/>
              <EngNew
              :data="{btnTitle: 'New', btnIcon: 'add'}"
              v-if="
              this.licenceOK &&
              this.userOK
              "/>
            </v-layout>
          </div>
          <div v-if="true" class="mt-4">
            <v-layout row class="text-xs-left ml-2 mr-2"
            v-if="true">
              <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                <v-avatar>
                <v-icon> {{this.defineDocumentFromTag("S6").icon}} </v-icon>
                </v-avatar>
                Create {{this.defineDocumentFromTag("S6").title}}
              </v-chip>
              <v-spacer/>
            </v-layout>
            <v-layout class="text-xs-left ml-4 mr-4 mt-2">
              <div :class="ui.textSubheading">
                {{this.defineDocumentFromTag("S6").card}}
              </div>
            </v-layout>
            <v-layout row class="mr-4">
              <v-spacer/>
              <IncidentNew :data="{btnTitle: 'New'}" v-if="this.licenceOK && this.userOK"/>
            </v-layout>
          </div>
          <div
          v-if="
          this.getUser.pref.select.cdid === '' &&
          this.getUser.pref.select.cdid !== null
          " class="mt-4">
            <v-layout row class="text-xs-left ml-2 mr-2"
            v-if="true">
              <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                <v-avatar>
                <v-icon :color="ui.colorWarning"> {{this.defineDocumentFromTag("C1").icon}} </v-icon>
                </v-avatar>
                <span :class="ui.textSubheadingWarning">
                  Select {{this.defineDocumentFromTag("C1").title}}
                </span>
              </v-chip>
              <v-spacer/>
            </v-layout>
            <v-layout class="text-xs-left ml-4 mr-4 mt-2">
              <div :class="ui.textSubheading">
                Select company to enable business functions.
              </div>
            </v-layout>
            <v-layout row>
            </v-layout>
          </div>
          <div
          v-if="
          this.getUser.pref.select.cdid !== '' &&
          this.getUser.pref.select.fdid === '' &&
          this.getUser.pref.select.cdid !== null &&
          this.getUser.pref.select.fdid !== null
          " class="mt-4">
            <v-layout row class="text-xs-left ml-2 mr-2"
            v-if="true">
              <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                <v-avatar>
                <v-icon :color="ui.colorWarning"> {{this.defineDocumentFromTag("F1").icon}} </v-icon>
                </v-avatar>
                <span :class="ui.textSubheadingWarning">
                  Select {{this.defineDocumentFromTag("F1").title}}
                </span>
              </v-chip>
              <v-spacer/>
            </v-layout>
            <v-layout class="text-xs-left ml-4 mr-4 mt-2">
              <div :class="ui.textSubheading">
                Select facility to enable business functions.
              </div>
            </v-layout>
            <v-layout row>
            </v-layout>
          </div>

        </v-card-text>
        <v-card-actions>
          <v-btn
          @click="dialog = false" :color="ui.btnColor" flat>
            <v-icon left> exit_to_app </v-icon>
            Close
          </v-btn>
          <v-spacer/>
          </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import apptheme from "@/frame/theme/mixins/apptheme.js";
import displayFunctions from "@/data/functions/mixins/displayFunctions.js";
import dateFunctions from "@/data/functions/mixins/dateFunctions.js";
import describeDocument from "@/data/describe/mixins/describeDocument";
import licenceFunctions from "@/admin/functions/mixins/licenceFunctions.js";
import adminFunctions from "@/admin/functions/mixins/adminFunctions.js";
import IncidentNew from "@/safety/incident/components/IncidentNew";
import WorkRequestNew from "@/work/request/components/WorkRequestNew";
import OpsNew from "@/operations/notification/components/OpsNew";
import EngNew from "@/engineering/engineering/components/EngNew";

export default {
  data() {
    return {
      dialog: false,
      valid: false,
      indeterminateProgressBar: false
    };
  },
  components: {
    WorkRequestNew,
    IncidentNew,
    OpsNew,
    EngNew
  },
  props: {
    data: {
      type: Object
    }
  },
  computed: {
    ...mapGetters(["getUser"])
  },
  // eslint-disable-next-line
  mixins: [
    apptheme,
    dateFunctions,
    displayFunctions,
    describeDocument,
    licenceFunctions,
    adminFunctions
  ],
  methods: {
    openDialog() {
      this.dialog = true;
    },
    closeDialog() {
      this.dialog = false;
    }
  }
};
</script>
